import type {CoreDiaryEntryApiModel} from '../../../../../api/types/core/models';

export abstract class CreateDiaryEntryCmd {
  abstract exec(
    props: CreateDiaryEntryCmd.Props,
  ): Promise<CreateDiaryEntryCmd.Response>;
}

export namespace CreateDiaryEntryCmd {
  export type Props = Pick<CoreDiaryEntryApiModel, 'type'> &
    Partial<
      Pick<
        CoreDiaryEntryApiModel,
        'attachment_ids' | 'content' | 'energy_level' | 'mood'
      >
    >;
  export type Response = CoreDiaryEntryApiModel;
}
